<template>
    <div>
        <div class="box">
            <BInputText
                v-model="orgInfo.name"
                :maxLength="25"
                :required="true"
                label-text="机构全称"
                placeholder="请输入机构全称"
            />
            <BInputText
                v-model="orgInfo.shortName"
                :maxLength="5"
                :required="true"
                label-text="机构简称"
                placeholder="请输入机构简称"
            />
        </div>
        <div class="box">
            <BInputText
                v-model="orgInfo.orgAbr"
                :maxLength="5"
                :required="true"
                label-text="机构代码"
                placeholder="请输入机构代码"
            />
        </div>
        <!-- <div class="box">
            <BInputPullDown
                label-name="区域"
                placeholder="请选择"
                :required="true"
                v-model="orgInfo.areaId"
                :Options="provinceList"
            />
            </div>
        -->
        
        <div class="box">
            <BInputText
                v-model="orgInfo.address"
                :maxLength="255"
                label-text="详细地址"
                placeholder="请输入详细地址"
                :inputLength=400
            />
        </div>
        <div class="box">
            <BInputText
                v-model="orgInfo.supervisorName"
                :maxLength="5"
                label-text="法人名"
                placeholder="请输入法人名"
            />
            <BInputText
                v-model="orgInfo.supervisorTel"
                :maxLength="11"
                label-text="电话"
                placeholder="请输入电话"
            />
        </div>
        <div class="box">
            <BInputText
                v-model="orgInfo.contactName"
                :maxLength="25"
                label-text="联系人"
                placeholder="请输入联系人"
            />
            <BInputText
                v-model="orgInfo.contactTel"
                :maxLength="11"
                label-text="电话"
                placeholder="请输入电话"
            />
        </div>
        <div class="box">
            <BInputText
                v-model="orgInfo.cdnUrl"
                :required="true"
                label-text="cdn"
                placeholder="请输入cdn地址"
                :inputLength=400
            />
        </div>
        
        <div class="search-result">
            <div class="search-functions-headers">
                <div class="search-functions">
                    <BBtnPrimary style="margin-left: 50px;"
                        v-if="orgId === '' || orgId === null || orgId === undefined"
                        :clicked="save"
                        btn-txt="添加"
                    />
                    <BBtnPrimary v-else :clicked="save" btn-txt="修改"/>
                    <BBtnPrimary :clicked="back" btn-txt="返回"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
    addInit,orgUpdate,orgSave,addOrgDetail
    } from "@/api/organizationSystem";
    import BInputText from "../../components2/BInputText";
    // import BInputPullDown from "../../components2/BInputPullDown";
    import BBtnPrimary from "../../components2/BBtnPrimary";
    import Vue from "vue";
    export default {
        name: "OrganizationManagementAdd",
        components: {
            BInputText,
            BBtnPrimary,
        },
        data: () => ({ 
            // 机构信息
            orgInfo: {
                name: "",
                shortName: "",
                areaId: "",
                address: "",
                supervisorName: "",
                supervisorTel: "",
                contactName: "",
                contactTel: "",
                orgAbr:"",
                cdnUrl: "",
            },
            // 机构id
            orgId:"",
            // 区域列表
            provinceList:[],
            navi: [
                {name: "organization-management"},
                {name: "organization-management-add"},
            ],
        }),
        created() {
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("store"))
                    )
                );
                sessionStorage.removeItem("store");
            }
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            });
        },
        destroyed() {
            this.$store.commit("REMOVE_ORGID");
        },
        // 页面载入之前
        beforeRouteEnter(to, from, next) {
            next((vm) => {

                const params = {
                    orgId: vm.$route.params.orgId,
                };
                if (
                    params.orgId !== null &&
                    params.orgId !== "" &&
                    params.orgId !== undefined
                ) {
                    // 把不为空的参数存入缓存
                    vm.$store.commit("SET_ORG_MANAGE_ADD_PARAMS", params);
                }
                // 参数赋值
                if (
                    vm.$store.state.orgManagement_orgAddId !== undefined &&
                    vm.$store.state.orgManagement_orgAddId !== null &&
                    vm.$store.state.orgManagement_orgAddId !== ""
                ) {
                    vm.orgId = vm.$store.state.orgManagement_orgAddId;
                }
                  vm.orgAddInit();

                if (
                    vm.orgId !== "" &&
                    vm.orgId !== null &&
                    vm.orgId !== undefined
                ) {
                    vm.orgInfoDetail(vm.orgId);
                }
            });
        },
        beforeMount() {
            this.$store.commit('SET_NAVI_DATA', this.navi);
        },
        methods: {
            // 添加初始化
            async orgAddInit() {
                const data = await addInit();
                this.provinceList = data.data;
            },
            // 机构详情
            async orgInfoDetail(id){
                var param = {
                    id: id,
                };
                const data = await addOrgDetail(param);
                this.orgInfo = {
                    name: data.data.name,
                    shortName: data.data.shortName,
                    areaId: data.data.areaId,
                    address: data.data.address,
                    supervisorName: data.data.supervisorName,
                    supervisorTel: data.data.supervisorTel,
                    contactName: data.data.contactName,
                    contactTel: data.data.contactTel,
                    orgAbr:data.data.orgAbr,
                    cdnUrl:data.data.cdnUrl,
                }
            },
            // 返回
            back() {
                if (
                    this.orgId !== null &&
                    this.orgId !== "" &&
                    this.orgId !== undefined
                ) {
                    this.$router.push({
                        name: "organization-management",
                        query: {backFlg: "1"},
                    });
                } else {
                    this.$router.push({
                        name: "organization-management",
                    });
                }
            },
            // 保存check
            saveCheck() {
                // 全称check
                if (
                    this.orgInfo.name === null ||
                    this.orgInfo.name === "" ||
                    this.orgInfo.name === undefined
                ) {
                    Vue.prototype.$valertbar.show("请输入全称");
                    return false;
                }
                // 简称check
                if (
                    this.orgInfo.shortName === null ||
                    this.orgInfo.shortName === "" ||
                    this.orgInfo.shortName === undefined
                ) {
                    Vue.prototype.$valertbar.show("输入简称");
                    return false;
                }
                // // 区域check
                // if (
                //     this.orgInfo.areaId === null ||
                //     this.orgInfo.areaId === "" ||
                //     this.orgInfo.areaId === undefined
                // ) {
                //     Vue.prototype.$valertbar.show("请选择区域");
                //     return false;
                // }
                // 法人手机号
                if(this.orgInfo.supervisorTel.length >0){
                    if (!this.comUtils.checkTelNo(this.orgInfo.supervisorTel)) {
                        Vue.prototype.$valertbar.show("'输入的负责人电话有错,请重新输入！");
                        return false
                    }
                }
                // 联系人手机号
                if(this.orgInfo.contactTel.length > 0 ){
                    if (!this.comUtils.checkTelNo(this.orgInfo.contactTel)) {
                        Vue.prototype.$valertbar.show("'输入的联系人电话有错,请重新输入！");
                        return false
                    }
                }
                // 机构代码check
                if(String(this.orgInfo.orgAbr).length > 0){
                    var regu = /^[A-Z]+$/;
                    if (
                        !regu.exec(String(this.orgInfo.orgAbr))
                    ) {
                        Vue.prototype.$valertbar.show("机构代码只能输入大写英文字符！");
                        return false;
                    }
                }else{
                     Vue.prototype.$valertbar.show("请输入机构代码！");
                     return false;
                }
                // cdn check
                if (
                    this.orgInfo.cdnUrl === null ||
                    this.orgInfo.cdnUrl === "" ||
                    this.orgInfo.cdnUrl === undefined
                ) {
                    Vue.prototype.$valertbar.show("请输入cdn地址");
                    return false;
                }
                return true;
            },
            // 保存
            save() {
                const param = {};
                if (this.saveCheck()) {
                    param.name = this.comUtils.trim(this.orgInfo.name);
                    param.shortName =  this.comUtils.trim(this.orgInfo.shortName);
                    param.areaId = this.orgInfo.areaId;
                    param.address = this.comUtils.trim(this.orgInfo.address);
                    param.supervisorName = this.comUtils.trim(this.orgInfo.supervisorName);
                    param.supervisorTel  = this.orgInfo.supervisorTel;
                    param.contactName = this.comUtils.trim(this.orgInfo.contactName);                    
                    param.contactTel = this.orgInfo.contactTel;
                    param.orgAbr = this.orgInfo.orgAbr
                    param.cdnUrl = this.orgInfo.cdnUrl
                    if (this.orgId) {
                        param.id = this.orgId;
                        this.orgUpdate(param);
                    } else {
                        this.orgSave(param);
                    }
                }
            },
            async orgSave(param) {
                const data = await orgSave(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.back()
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            async orgUpdate(param) {
                const data = await orgUpdate(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.back()
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
        }
    }
</script>

<style scoped>
.main2 {
        position: relative;
        /*margin: 5px 30px 5px 30px;*/
        padding-top: 28px;
        display: flex;
        flex-wrap: wrap;
    }

    .search-result {
        display: block;
        position: relative;
        margin: 30px 25px 5px 25px;
    }

    .search-functions-headers {
        position: relative;
        display: flex;
        justify-content: space-between;
        top: 0;
    }

    .search-functions {
        position: relative;
        top: 0;
        display: flex;
    }

    .search-result-summary {
        display: flex;
        align-items: center;
    }

    .search-result-summary .summary {
        margin: 0 50px 0 0;
    }

    .search-result-table {
        border-spacing: 0px;
        padding-bottom: 50px;
        width: 100%;
        margin-top: 10px;
    }

    .table-header-row {
        height: 67px;
        background: #f6f6f6;
    }

    .table-header-row th {
        text-align: left;
        padding: 10px;
    }

    .table-result-row {
        height: 78px;
        font-weight: 500;
        color: #333333;
    }

    .table-result-row td {
        border-bottom: 1px solid #ebebeb;
        padding: 10px;
        text-align: left;
    }

    .btn-detail {
        margin: 0 20px 0 20px;
        color: #0171a3;
        cursor: pointer;
    }

    .btn-delete {
        color: #fd1f58;
        cursor: pointer;
    }

    .box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-pick {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 90px;
    }

    .box-left {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
    }

    .box-right {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }

    .inner-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        justify-content: flex-start;
    }

    .label-box {
        color: #333333;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 10px;
    }

    .label-box-sign {
        text-align: right;
        color: #333333;
        font-size: 14px;
        margin: 0 10px 0 23px;
    }

    .subtitle {
        color: #999999;
        margin: 15px 10px 15px 20px;
    }
    .box-time{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
</style>